import React, { FC } from "react";
import { GuardianFormList } from "./Form";
import { GuardianFormSubmissionParsed } from "../../models/api-models/guardians/guardian-form-submission";
import { GuardianForm as IGuardianForm } from "../../models/api-models/guardians/guardian-form";

export interface GuardianProps {
    form: IGuardianForm,
    formSubmission: GuardianFormSubmissionParsed,
    isCurrentGuardianSinged: boolean,
    isOtherGuardiansSigned: boolean,
    currentGuardianIsActive: boolean,
}

export const GuardianForm: FC<GuardianProps> = ({ 
    form, formSubmission, isCurrentGuardianSinged, isOtherGuardiansSigned, currentGuardianIsActive
 }) => {
    return (
        <>
            <GuardianFormList 
                isOtherGuardiansSigned={isOtherGuardiansSigned} 
                currentGuardianIsActive={currentGuardianIsActive} 
                form={form} 
                formSubmission={formSubmission} 
                isCurrentGuardianSinged={isCurrentGuardianSinged}/>
        </>
    )
}